
export enum EdiSlashPoundCd {
	P = 'P',
	S = 'S'}

